import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let ticking = false;
    
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          setIsScrolled(window.scrollY > 50);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/team', label: 'Team' },
    { path: '/participate', label: 'Participate' }
  ];

  const handleNavClick = (path) => {
    // Close mobile menu if open
    setIsMobileMenuOpen(false);
    
    // Scroll to top when navigating with optimized performance
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Fallback for browsers that don't support smooth scrolling
      window.scrollTo(0, 0);
    }
  };

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <div className="logo-content">
              <div className="logo-text">
                <span className="logo-main">Canadian Biobank</span>
                {/* <span className="logo-sub">CBP</span> */}
              </div>
              <div className="logo-icon">🧠</div>
            </div>
          </Link>

          <nav className="nav">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={location.pathname === item.path ? "active" : ""}
                onClick={() => handleNavClick(item.path)}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <button
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle mobile menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="mobile-menu">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={location.pathname === item.path ? "active" : ""}
                onClick={() => handleNavClick(item.path)}
              >
                {item.label}
              </Link>
            ))}
          </div>
        )}
      </div>

      <style jsx>{`
        .mobile-menu {
          display: none;
          flex-direction: column;
          gap: 1rem;
          padding: 1rem 0;
          border-top: 1px solid rgba(0, 0, 0, 0.1);
        }

        .mobile-menu a {
          color: #333;
          text-decoration: none;
          font-weight: 500;
          padding: 0.5rem 0;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }

        .mobile-menu a:hover {
          color: #1E40AF;
        }

        .nav a.active {
          color: #1E40AF;
        }

        .nav a.active::after {
          width: 100%;
        }

        @media (max-width: 768px) {
          .mobile-menu {
            display: flex;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;
